export const getPropertyFromGeocoderResult = (result, property) =>
	result.address_components.find((addressComponent) =>
		addressComponent.types.includes(property),
	)?.short_name;

export const getGeocoderResultProperties = (result) => ({
	address1: (result.formatted_address || "").split(",")[0] || result.name,
});
